export default {
  namespaced: true,

  state: {
    dataTable: null,
    fileExel: null,
    formType: null
  },

  getters: {},

  mutations: {
    setData(state, payload) {
      state.dataTable = payload
    },

    setStatusId(state, payload) {
      state.dataTable.statusId = payload
    },

    setFileExel(state, payload) {
      state.fileExel = payload.file
      state.formType = payload.formType
    },

    reset(state) {
      state.formType = null
      state.fileExel = null
      state.dataTable = null
    }
  },

  actions: {}
}
